/**
 * @file - MitIDButton.js
 * MitID login button that opens MitID login
 */

import Link from "@/components/base/link";
import Icon from "@/components/base/icon";
import Button from "@/components/base/button";
import Text from "@/components/base/text";
import styles from "./MitIDButton.module.css";
import Translate from "@/components/base/translate";
import { signIn } from "@dbcdk/login-nextjs/client";
import { getCallbackUrl } from "@/components/_modal/pages/login/utils";
import { useLastLoginBranch } from "@/components/hooks/useLastLoginBranch";
import useDataCollect from "@/lib/useDataCollect";
import MitIdSvg from "@/public/icons/MitID.svg";

/**
 * Shows MitID login button and opens MitID login
 * @param {string} callbackUrl
 * @returns
 */
export default function MitIDButton({ callBackUUID, redirectPath }) {
  const callBackUrl = getCallbackUrl(null, callBackUUID, { redirectPath });
  const { removeLastLoginBranch } = useLastLoginBranch();
  const collect = useDataCollect();
  const onMitIdLogin = () => {
    collect.collectUseMitID();
    removeLastLoginBranch();
    signIn(
      "adgangsplatformen",
      { callbackUrl: callBackUrl },
      { force_login: 1, idp: "nemlogin" }
    );
  };

  return (
    <section className={styles.mitIDSection}>
      <Text type="text2" className={styles.hideOnSmallScreen}>
        {Translate({ context: "login", label: "or-mit-id" })}
      </Text>
      <Button
        ariaLabel={Translate({ context: "login", label: "mit-id" })}
        dataCy="mitid-button"
        type="secondary"
        size="large"
        className={styles.mitIDButton}
        onClick={onMitIdLogin}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            onMitIdLogin();
          }
        }}
      >
        <Icon alt="mitID" size={{ h: "2" }} className={styles.mitIDIcon}>
          <MitIdSvg />
        </Icon>
      </Button>
      {/**dont show on mobile */}
      <Link
        onClick={() => {
          collect.collectCreateLibraryUser();
        }}
        href="/artikel/ny-bruger-paa-bibliotek-dk/al20u5vp18nq82dvzhhct6pd"
        className={styles.createLibraryUserLink}
        border={{ bottom: { keepVisible: true } }}
      >
        <Text type="text3" tag="span">
          {Translate({ context: "login", label: "create-library-user" })}
        </Text>
      </Link>
    </section>
  );
}
